import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Button, Link } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { WizardStepIndex } from "../../../shared/enums/WizardStep";
import { GA4ProductGuideSteps } from "../../../shared/enums/GA4ProductGuideSteps";
import { linkHelper } from "../../../shared/helpers/linkHelper";
import { styleHelper } from "../../../shared/helpers/styleHelper";
import { action } from "../../../store/action";
import { useMarket } from "../../../store/hooks/useMarket";
import { useMachineTonnage } from "../../../store/hooks/useMachineTonnage";
import { Wizard } from "../../../store/interfaces/Wizard";
import CustomContainer from "../../shared/CustomContainer";
import "./WizardNavigation.scss";
import { useCartSelections } from "../../../store/hooks/useCartSelections";
import { cookies } from "../../../shared/helpers/cookies";
import { useCartProduct } from "../../../store/hooks/useCartProduct";
import { useCartOptional } from "../../../store/hooks/useCartOptional";
declare global {
  interface Window {
    dataLayer: any[];
  }
}

interface WizardNavigationProps {
  wizard: Wizard;
}

const WizardNavigation = ({ wizard }: WizardNavigationProps) => {
  const { t } = useTranslation("footer");
  const dispatch = useDispatch();
  const market  = useMarket();
  const flagMarket = cookies.getFlagMarket();
  const machineTonnage = useMachineTonnage();
  const cart = useCartSelections();
  const cartProduct = useCartProduct();
  const cartOptional = useCartOptional();
  const { width } = useWindowDimensions();
  const mediumScreen = 720;
  let nextButtonStyle = true;
  let productStepItems;
  let optionalStepItems;

  if (width > mediumScreen) {
    nextButtonStyle = false;
  }

  if (!wizard) {
    return (
      <div className="navigationContainer">
        <div className="navigation"></div>
      </div>
    );
  }

  const pushToDataLayer = () => {
    const machine = machineTonnage?.machineModel?.name;
    const tonnage = machineTonnage?.tonnage;
    let selectedMarket;
    if(flagMarket != "") {
      selectedMarket = flagMarket;
    }
    else {
      selectedMarket = market;
    }
    const products =  [];
    let selectedPath = "";
    const optional = [];
    if(cart?.product) {
      productStepItems = cart.product
      if(productStepItems?.tiltrotator) {
        selectedPath = "Tiltrotator path selected"
      } else if(productStepItems?.machineFixing) {
        selectedPath = "Machine fixing path selected"
      }else if(productStepItems?.toolsProductItems) {
        selectedPath = "Tools path selected"
      }
      if(productStepItems?.tiltrotator?.name) {
        products.push("Tiltrotator: " + productStepItems?.tiltrotator?.name)
      }
      if(productStepItems?.machineFixing?.name) {
        products.push("MachineCoupler: " + productStepItems?.machineFixing?.name)
      }
      if(productStepItems?.upperBracket?.name) {
        products.push("UpperBracket: " + productStepItems?.upperBracket?.name)
      }
      if(productStepItems?.grappleModule?.name) {
        products.push("GrappleModule: " + productStepItems?.grappleModule?.name)
      }      
      if(productStepItems?.lowerBracket?.name) {
        products.push("LowerBracket: " + productStepItems?.lowerBracket?.name)
      }
   
  if (productStepItems?.toolsProductItems && productStepItems?.toolsProductItems.length > 0) {
    products.push("Selected tools:")
    productStepItems.toolsProductItems.forEach(tool => {
      products.push(tool.name)
    });
  }
    }
    else {
      productStepItems = cartProduct;
      if(productStepItems?.tiltrotator) {
        selectedPath = "Tiltrotator path selected"
      } else if(productStepItems?.machineFixing) {
        selectedPath = "Machine fixing path selected"
      }else if(productStepItems?.toolsProductItems) {
        selectedPath = "Tools path selected"
      }
      if(productStepItems?.tiltrotator?.name) {
        products.push("Tiltrotator: " + productStepItems?.tiltrotator?.name)
      }
      if(productStepItems?.machineFixing?.name) {
        products.push("MachineCoupler: " + productStepItems?.machineFixing?.name)
      }
      if(productStepItems?.upperBracket?.name) {
        products.push("UpperBracket: " + productStepItems?.upperBracket?.name)
      }
      if(productStepItems?.grappleModule?.name) {
        products.push("GrappleModule: " + productStepItems?.grappleModule?.name)
      }      
      if(productStepItems?.lowerBracket?.name) {
        products.push("LowerBracket: " + productStepItems?.lowerBracket?.name)
      }
   
  if (productStepItems?.toolsProductItems && productStepItems?.toolsProductItems.length > 0) {
    products.push("Selected tools:")
    productStepItems.toolsProductItems.forEach(tool => {
      products.push(tool.name)
    });
  }
    }
    if(cart?.optional) {
      optionalStepItems = cart.optional

      if(optionalStepItems?.tiltrotator?.name) {
        optional.push("Tiltrotator: " + optionalStepItems?.tiltrotator?.name)
      }
      if(optionalStepItems?.machineFixing?.name) {
        optional.push("MachineCoupler: " + optionalStepItems?.machineFixing?.name)
      }
      if(optionalStepItems?.grappleModule?.name) {
        optional.push("GrappleModule: " + optionalStepItems?.grappleModule?.name)
      }
      if (optionalStepItems?.toolsProductItems && optionalStepItems?.toolsProductItems.length > 0) {
        optional.push("Selected tools:")
        optionalStepItems.toolsProductItems.forEach(tool => {
          optional.push(tool.name)
        });
      }
    }
    else {
      optionalStepItems = cartOptional;
      if(optionalStepItems?.tiltrotator?.name) {
        optional.push("Tiltrotator: " + optionalStepItems?.tiltrotator?.name)
      }
      if(optionalStepItems?.machineFixing?.name) {
        optional.push("MachineCoupler: " + optionalStepItems?.machineFixing?.name)
      }
      if(optionalStepItems?.grappleModule?.name) {
        optional.push("GrappleModule: " + optionalStepItems?.grappleModule?.name)
      }
      if (optionalStepItems?.toolsProductItems && optionalStepItems?.toolsProductItems.length > 0) {
        optional.push("Selected tools:")
        optionalStepItems.toolsProductItems.forEach(tool => {
          optional.push(tool.name)
        });
      }
    }
    const json = {
      ...(machine ? { machine: machine } : {}),
      ...(selectedMarket ? { market: selectedMarket } : {}),
      ...(tonnage ? { tonnage: tonnage } : {}),
      ...(selectedPath ? {selectedPath: selectedPath} : {}),
      ...(products ? { products: products } : {}),
      ...(optional ? { optional: optional } : {})
    };
    window.dataLayer = window.dataLayer || [];
    if (wizard.activeStepIndex === WizardStepIndex.Market) {
      window.dataLayer.push({
        event: GA4ProductGuideSteps.Market,
        json,
      });
    }
    if (wizard.activeStepIndex === WizardStepIndex.MachineTonnage) {
      window.dataLayer.push({
        event: GA4ProductGuideSteps.MachineTonnage,
        json,
      });
    }
    if (wizard.activeStepIndex === WizardStepIndex.Product) {
      window.dataLayer.push({
        event: GA4ProductGuideSteps.Product,
        json,
      });
    }
    if (wizard.activeStepIndex === WizardStepIndex.Optional) {
      window.dataLayer.push({
        event: GA4ProductGuideSteps.Optional,
        json,
      });
    }
    if (wizard.activeStepIndex === WizardStepIndex.ContactUs) {
      window.dataLayer.push({
        event: GA4ProductGuideSteps.ContactUs,
        json,
      });
    }
  };
  const { enableNext } = wizard;
  const { previousLink, nextLink } = linkHelper.navigationLinks(
    wizard.activeStepIndex,
    market
  );
  


  const onNextClick = () => {
    pushToDataLayer();
    if (wizard.activeStepIndex === WizardStepIndex.Product) {
      dispatch(action.moveCartProductSelectionsToCart());
      return;
    }

    if (wizard.activeStepIndex === WizardStepIndex.Optional) {
      dispatch(action.moveCartOptionalSelectionsToCart());
      return;
    }
  };

  return (
    <div className="navigationContainer">
      <CustomContainer>
        {wizard && (
          <div className="navigation">
            <div>
              {previousLink && market && (
                <Link
                  to={previousLink}
                  component={RouterLink}
                  className="bottomNavLinkPrev"
                  sx={{
                    color: "#2b3035",
                    textDecoration: "none",
                  }}
                >
                  <div className="bottomNavPrevText">
                    <ChevronLeftIcon />
                    <span>{t("previous")}</span>
                  </div>
                </Link>
              )}
            </div>
            <div>
              {nextLink && market && (
                <RouterLink
                  onClick={onNextClick}
                  to={nextLink}
                  className={`${
                    enableNext
                      ? "bottomNavLinkNext"
                      : "bottomNavLinkNextDisabled"
                  }`}
                >
                  <Button
                    variant={`${nextButtonStyle ? "text" : "contained"}`}
                    disabled={!enableNext}
                    style={styleHelper.button}
                    sx={{
                      "@media (max-width: 720px)": {
                        fontWeight: "700",
                        color: "#db0f0f",
                        fontSize: "16px",
                      },
                    }}
                  >
                    {t("next")}
                    {nextButtonStyle ? <ChevronRightIcon /> : ""}
                  </Button>
                </RouterLink>
              )}
            </div>
          </div>
        )}
      </CustomContainer>
    </div>
  );
};

export default WizardNavigation;
